var React = require('react');

function Stroke4Blue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#2E56B4","strokeWidth":"13","d":"M1477 19s-169-45-389 39c-128 48-289 160-493 186s-410-81-636-73"}));
}

Stroke4Blue.defaultProps = {"viewBox":"0 0 1440 255"};

module.exports = Stroke4Blue;

Stroke4Blue.default = Stroke4Blue;
